import { render, staticRenderFns } from "./ContestEntryTopWidget.vue?vue&type=template&id=509d5768"
import script from "./ContestEntryTopWidget.vue?vue&type=script&lang=js"
export * from "./ContestEntryTopWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports